import * as Yup from 'yup'

import { SubjectData } from 'adminConsole/store'

let subjectSchema = Yup.object({
  supNo: Yup.string().trim().required(),
  model: Yup.string().trim().required(),
  capacity: Yup.string().trim().required(),
  mara: Yup.string().trim().required(),
  price: Yup.number().integer().positive().required(),
  productNo: Yup.string().trim().when('productCategory', {
    is: 'laptop',
    then: Yup.string().trim().required(),
  }),
  productCategory: Yup.string().trim().oneOf(['phone', 'accessories', 'laptop']).required(),
  launchDay: Yup.date().required(),
})

export const validateSubjects = (subjects: SubjectData[]) => {
  let validSubjects: SubjectData[] = []
  let invalidSubjects: SubjectData[] = []

  const errorMap: Record<string, Record<string, string>> = {}

  subjects.forEach(subject => {
    try {
      subjectSchema.validateSync(subject, { abortEarly: false })
      validSubjects.push(subject)
    } catch (error: any) {
      invalidSubjects.push(subject)

      const fieldErrors: Record<string, string> = {}
      error.inner.forEach((err: Yup.ValidationError) => {
        if (err.path && !fieldErrors[err.path]) fieldErrors[err.path] = err.message
      })
      const key = `${subject.capacity}-${subject.model}`
      errorMap[key] = fieldErrors
    }
  })

  if (process.env.REACT_APP_ENV_TYPE !== 'production') console.log('商品匯入檢核未通過:', errorMap)

  return { validSubjects, invalidSubjects }
}
